import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const selectButtonFn = /* @__PURE__ */ createRecipe('select-button', {}, [])

const selectButtonVariantMap = {}

const selectButtonVariantKeys = Object.keys(selectButtonVariantMap)

export const selectButton = /* @__PURE__ */ Object.assign(memo(selectButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'selectButton',
  __getCompoundVariantCss__: selectButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: selectButtonVariantKeys,
  variantMap: selectButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, selectButtonVariantKeys)
  },
  getVariantProps: selectButtonFn.getVariantProps,
})